import { haleBrandConfig } from './hale.config';
import { studentBrandConfig } from './student.config';
import { BrandKey, BrandThemeConfig } from './types';

export const DEFAULT_BRAND_KEY: BrandKey = 'student';

export const BRAND_REGISTRY: Record<BrandKey, BrandThemeConfig> = {
  student: studentBrandConfig,
  hale: haleBrandConfig,
};

export const getBrandConfig = (key: BrandKey): BrandThemeConfig =>
  BRAND_REGISTRY[key] ?? BRAND_REGISTRY[DEFAULT_BRAND_KEY];

export const findBrandByIds = (
  buId?: string | number | null,
  appId?: string | number | null,
): BrandKey | null => {
  const brands = Object.values(BRAND_REGISTRY);

  if (buId != null && buId !== '') {
    const match = brands.find((brand) => brand.buId === Number(buId));
    if (match) return match.key;
  }

  if (appId != null && appId !== '') {
    const matches = brands.filter((brand) => brand.appId === Number(appId));
    if (matches.length === 1) {
      return matches[0].key;
    }
  }

  return null;
};
